import { Component, Input, OnInit } from '@angular/core';

import { Header } from '../../models/task-ejecucion';

@Component({
  selector: 'toolbar-foto-exito',
  templateUrl: './toolbar-foto-exito.component.html',
  styleUrls: ['./toolbar-foto-exito.component.scss'],
})
export class ToolbarFotoExitoComponent implements OnInit {

  @Input() header: Header = {}
  @Input() minutes = 0
  @Input() isComplete = false
  @Input() timer = ''
  @Input() disableBack = false;

  constructor() { }

  ngOnInit() { }

}
